import noop from 'utils/noop';
import { useFormContext } from 'react-hook-form';
import { EmbeddedPreviewContext } from 'modules/templateEditor/EditEmbedded/context/EmbeddedPreviewContext';
import { toggleToActionButton } from 'modules/placements/utils';
import { PreviewPane } from 'modules/templateEditor/EditEmbedded/preview/PreviewPane';
import { FC } from 'react';
import { PageHeader } from './components';
import { DeliveryContentBlock } from './DeliveryContentBlock';
import { DetailsContentBlock } from './DetailsContentBlock';
import { PlacementContentBlock } from './PlacementContentBlock';
import { MainSection, SettingsWrapper, PreviewWrapper } from './styles';
import { PlacementsCreateFormProvider } from './PlacementsCreateFormProvider';

const withFormProvider = (Component: FC<React.PropsWithChildren<unknown>>) => (props: any) => {
  return (
    <PlacementsCreateFormProvider>
      <Component {...props} />
    </PlacementsCreateFormProvider>
  );
};

export const PlacementsCreate = withFormProvider(() => {
  const { watch } = useFormContext();

  const [name, mediaLayout, hasTitle, hasBody, actionButtons] = watch([
    'name',
    'mediaLayout',
    'hasTitle',
    'hasBody',
    'actionButtons',
  ]);

  const previewContextValues = {
    isLoading: false,
    title: hasTitle ? 'Title' : '',
    body: hasBody ? 'Body' : '',
    actionButtons: toggleToActionButton(actionButtons),
    mediaUrl: '',
    hasContent: true,
    previewError: undefined,
    onRefreshPreview: noop,
  };

  return (
    <>
      <PageHeader name={name} />
      <MainSection>
        <SettingsWrapper>
          <PlacementContentBlock />
          <DetailsContentBlock />
          <DeliveryContentBlock />
        </SettingsWrapper>
        <EmbeddedPreviewContext.Provider value={previewContextValues}>
          <PreviewWrapper>
            <PreviewPane mediaLayout={mediaLayout} />
          </PreviewWrapper>
        </EmbeddedPreviewContext.Provider>
      </MainSection>
    </>
  );
});
